"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategyAttributeItem = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const classnames_1 = __importDefault(require("classnames"));
const hooks_1 = require("./hooks");
const strategy_attribute_item_styles_1 = require("./strategy-attribute-item.styles");
const attribute_value_list_container_1 = require("../attribute-value-list.container");
const components_1 = require("../../../../components");
const generic_1 = require("../../../../generic");
const hooks_2 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const slotProps = { transition: { unmountOnExit: true } };
const StrategyAttributeItem = react_1.default.forwardRef((_a, forwardedRef) => {
    var { attributeName, productCount = 0, isSelected, isSelectDisabled, isCheckDisabled, columnCount, itemWidth, itemMaxWidth, isChecked, keepExpanded, selectedAttributeValue, sortingItem, isValueCheckDisabled, isChanged, isMeasure, selectedMeasureUnit, isValid, checkIsValueChecked, onToggleExpand, onSelect, onCheck, onEdit } = _a, accordionProps = __rest(_a, ["attributeName", "productCount", "isSelected", "isSelectDisabled", "isCheckDisabled", "columnCount", "itemWidth", "itemMaxWidth", "isChecked", "keepExpanded", "selectedAttributeValue", "sortingItem", "isValueCheckDisabled", "isChanged", "isMeasure", "selectedMeasureUnit", "isValid", "checkIsValueChecked", "onToggleExpand", "onSelect", "onCheck", "onEdit"]);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { onStrategizeValue } = (0, hooks_1.useStrategizeValue)({ attributeName });
    const handleChange = (0, react_1.useCallback)((_, expanded) => onToggleExpand({
        label: attributeName,
        isMeasure,
        isAIEnriched: !isMeasure,
    }, expanded), [attributeName, isMeasure, onToggleExpand]);
    const { expanded } = accordionProps, otherProps = __rest(accordionProps, ["expanded"]);
    const handleCheck = (event, checked) => {
        event.stopPropagation();
        onCheck({ label: attributeName }, checked);
    };
    const handleLogIconClick = (e) => {
        e.stopPropagation();
        onEdit === null || onEdit === void 0 ? void 0 : onEdit(attributeName);
    };
    const ref = (0, react_1.useRef)(null);
    const isIntersecting = (0, hooks_2.useIsVisible)(ref);
    const { data, isLoading, isRefetching, attributeProductCount, isAttributeModified, pagination: { isLoadingMore, onNextPage, hasNextPage, }, error, } = (0, hooks_1.useAttributeValues)({
        attributeName,
        sortingItem,
        isMeasure,
        options: { skip: !isIntersecting || !expanded },
    });
    const shouldShowPreloader = isLoading && !isRefetching;
    const renderAttributeValueList = () => {
        const showOnlySelectedValue = keepExpanded && !expanded;
        const showValues = !shouldShowPreloader && !error && (expanded || showOnlySelectedValue);
        return showValues ? (react_1.default.createElement(attribute_value_list_container_1.AttributeValueList, { values: data, attributeName: attributeName, isDisabled: isSelectDisabled, showOnlySelectedValue: showOnlySelectedValue, isCheckDisabled: isValueCheckDisabled || isAttributeModified, isAttributeSelected: isSelected, isAttributeModified: isAttributeModified, selectedMeasureUnit: selectedMeasureUnit, selectedAttributeValue: selectedAttributeValue, columnCount: columnCount, itemWidth: itemWidth, itemMaxWidth: itemMaxWidth, hasNextPage: hasNextPage, moreItemsLoading: isLoadingMore, checkIsValueChecked: checkIsValueChecked, onSelect: onSelect, onCheck: onCheck, onLoadMore: onNextPage, onStrategize: onStrategizeValue })) : null;
    };
    return (react_1.default.createElement(strategy_attribute_item_styles_1.StyledAccordion, Object.assign(Object.assign({}, otherProps), { ref: ref, expanded: expanded || keepExpanded, slotProps: slotProps, onChange: (e) => handleChange(e, !expanded) }), react_1.default.createElement(strategy_attribute_item_styles_1.StyledAccordionSummary, { ref: forwardedRef, expandIcon: react_1.default.createElement(icons_material_1.ExpandMore, { color: "primary", className: (0, classnames_1.default)({ 'expand-icon--expanded': expanded }) }) }, react_1.default.createElement(generic_1.AttributeCheckbox, { checked: isChecked, onClick: (e) => e.stopPropagation(), onChange: handleCheck, disabled: isCheckDisabled }), react_1.default.createElement(ui_components_1.Typography, { strong: true, variant: "overline", color: "textSecondary", className: "attribute-title" }, `${attributeName} (${attributeProductCount !== null && attributeProductCount !== void 0 ? attributeProductCount : productCount})`), !isMeasure && isValid && onEdit && react_1.default.createElement(generic_1.GuidelineButton, { tooltipText: t({ key: 'MANAGE_ATTRIBUTE' }), onClick: handleLogIconClick }), isChanged && react_1.default.createElement(generic_1.ChangeMark, { className: "attribute-change-mark" })), renderAttributeValueList(), (shouldShowPreloader || error) && (react_1.default.createElement(material_1.AccordionDetails, null, shouldShowPreloader && react_1.default.createElement(generic_1.LoadingIndicator, null), error && react_1.default.createElement(components_1.Alert, { severity: "error" }, error.message)))));
});
StrategyAttributeItem.displayName = 'StrategyAttributeItem';
const MemoizedStrategyAttribute = react_1.default.memo(StrategyAttributeItem);
exports.StrategyAttributeItem = MemoizedStrategyAttribute;
exports.default = MemoizedStrategyAttribute;
